const POLL_INTERVAL_MSEC = 10000;

const COLOR_BY_LEVEL = {
  success: "kale",
  error: "radish",
  info: "starflower",
};

const applyStatus = (element, status) => {
  element.textContent = status.text;
  Object.values(COLOR_BY_LEVEL).forEach((color) =>
    element.classList.remove(color)
  );
  element.classList.add(COLOR_BY_LEVEL[status.level] || "kale");
  element.dataset.pending = status.pending;
};

const pendingElements = () =>
  [].slice.call(
    document.querySelectorAll(".js-connection-status[data-pending='true']")
  );

const poll = (endpoint) => {
  fetch(endpoint, { method: "GET", credentials: "same-origin" })
    .then((response) => response.json())
    .then((data) => {
      pendingElements().forEach((element) => {
        const status = data[element.dataset.exporter];
        if (status) applyStatus(element, status);
      });
    })
    .catch((err) => console.error(`Error polling integration status: ${err}`));
};

const start = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(
      "[data-integration-status-endpoint]"
    );
    if (!container || pendingElements().length === 0) return;

    const endpoint = container.dataset.integrationStatusEndpoint;
    const interval = setInterval(() => {
      if (pendingElements().length === 0) {
        clearInterval(interval);
        return;
      }
      poll(endpoint);
    }, POLL_INTERVAL_MSEC);
  });
};

export { start };
